<template>
	<section class="comparison" :class="classObject">
		<header>
			<h2 class="beta" v-html="$present('ucWords', comparison.type) + ' Comparison'"/>
		</header>
		<div class="detail-list">
			<dl class="detail-list__item">
				<dt>Id</dt>
				<dd v-html="comparison.id"/>
			</dl>
			<dl class="detail-list__item">
				<dt>Created</dt>
				<dd v-html="$present('date', comparison.created_at)"/>
			</dl>
			<dl class="detail-list__item" v-if="comparison.serviceProvider">
				<dt>Source</dt>
				<dd v-html="comparison.serviceProvider.profile.name"/>
			</dl>
			<dl class="detail-list__item">
				<dt>Type</dt>
				<dd v-html="comparison.type"/>
			</dl>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		comparison: {
			required: true,
			type: Object,
		},
	},

	computed: {
		classObject() {
			return {
				"client__service--instructed": this.comparison.active_instruction,
			};
		},
	},
};
</script>
